import { Controls } from '../controls';

const turkishCharacters = ['İ', 'Ş', 'Ü', 'Ğ', 'Ö', 'Ç', 'ı', 'ş', 'ü', 'ğ', 'ö', 'ç'];

const englishCounterparts = ['I', 'S', 'U', 'G', 'O', 'C', 'i', 's', 'u', 'g', 'o', 'c'];

const _StringTurkishToEnglishCharacters = (input: any | null | undefined): any | undefined => {
  if (input === null || input === undefined) return undefined;
  if (!Controls.IsString(input)) {
    return input;
  }
  let _input: string = input;
  for (let i = 0; i < turkishCharacters.length; i++) {
    if (_input.indexOf(turkishCharacters[i]) > -1) {
      _input = _input.replace(new RegExp(turkishCharacters[i], 'g'), englishCounterparts[i]);
    }
  }
  return _input;
};

export const FormatString = {
  StringTurkishToEnglishCharacters: _StringTurkishToEnglishCharacters,
};
